const Numbers = {
    init() {
        const scrollingNumbers = [].slice.call(document.querySelectorAll(".countable"));
        scrollingNumbers.forEach(function(element) {
            Numbers.numbersObserver.observe(element);
        });
    },
    animateValue(obj) {
        let end = parseInt(obj.dataset.end, 10);
        let current = 0;
        let increment = end / 8;
        let stepTime = 80;
        const objNr = obj.querySelector('span');
        let timer = setInterval(function() {
            current += increment;
            objNr.innerHTML = current.toFixed(0).toString();
            if (current > end) {
                objNr.innerHTML = end.toLocaleString('en-GB');
                clearInterval(timer);
            }
        }, stepTime);
    },
    numbersObserver: new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                Numbers.animateValue(entry.target);
                entry.target.parentElement.classList.add('counted');
                Numbers.numbersObserver.unobserve(entry.target);
            }
        });
    })
};

export default Numbers;
